module.exports = __webpack_public_path__ + "img/la-brands-400.9769d0a.svg";